import { Box } from '~/commonComponents';
import { Tab, TabList, Tabs } from '~/commonComponents/Tabs';
import { Colors } from '~/themes/colors';
import { OnsiteInterviewStatus } from '../../utils';

const TitleCopy = {
  [OnsiteInterviewStatus.ActionNeeded]: 'Action Needed',
  [OnsiteInterviewStatus.Cancelled]: 'Cancelled & Expired',
  [OnsiteInterviewStatus.Completed]: 'Completed',
  [OnsiteInterviewStatus.Open]: 'Open',
  [OnsiteInterviewStatus.Scheduled]: 'Scheduled',
};

const DotColors = {
  [OnsiteInterviewStatus.ActionNeeded]: Colors.error_450,
  [OnsiteInterviewStatus.Cancelled]: Colors.warning_500,
  [OnsiteInterviewStatus.Completed]: Colors.neutral_400,
  [OnsiteInterviewStatus.Open]: Colors.success_500,
  [OnsiteInterviewStatus.Scheduled]: Colors.secondary_500,
};

interface IOnsiteInterviewStatusFilterPanelProps {
  counts: Record<OnsiteInterviewStatus, number>;
  onChange(tab: OnsiteInterviewStatus | 'all'): void;
}

export const OnsiteInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IOnsiteInterviewStatusFilterPanelProps) => {
  const tabs = [
    OnsiteInterviewStatus.ActionNeeded,
    OnsiteInterviewStatus.Open,
    OnsiteInterviewStatus.Scheduled,
    OnsiteInterviewStatus.Completed,
    OnsiteInterviewStatus.Cancelled,
  ];
  const totalCount = Object.values(counts).reduce((sum, count) => sum + count, 0);

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx - 1] || 'all');
  };

  return (
    // @ts-expect-error JS Component
    <Tabs tabListStyle={{ gap: 16 }} onChangeTab={handleTabChange}>
      {/* @ts-expect-error JS Component */}
      <TabList>
        <Tab
          title={`All Active${totalCount > 0 ? ` (${totalCount})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {tabs.map((it) => (
          <Tab
            PrefixComponent={
              <Box backgroundColor={DotColors[it]} borderRadius="100%" height={10} width={10} />
            }
            key={it}
            title={`${TitleCopy[it]}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
